<template>
  <!-- render nothing on image. scribble handles it. -->
  <div v-if="shouldRender" class="w-full h-full relative overflow-hidden">
    <CSlideViewerPspdfkit
      v-if="rendererName === 'pspdfkit'"
      class="absolute inset-0"
      :page-index="pageIndex"
      :pdf-url="pdfUrl"
      @pdf-loaded="$emit('pdfLoaded')"
    />
    <CSlideViewerPdfjs
      v-else-if="rendererName === 'pdfjs'"
      class="absolute inset-0"
      :page-index="pageIndex"
      :pdf-url="pdfUrl"
      @pdf-loaded="$emit('pdfLoaded')"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, inject, type ComputedRef } from 'vue'

import CSlideViewerPdfjs from './CSlideViewer.pdfjs.vue'
import CSlideViewerPspdfkit from './CSlideViewer.pspdfkit.vue'
import type { OrganizationSettings } from '@lib/types/organizationSettings.types'
import type { InstanceSettings } from '@lib/types/instanceSettings.types'

const props = withDefaults(defineProps<{ pageIndex?: number; pdfUrl: string }>(), {
  pageIndex: 0,
})

defineEmits<{ pdfLoaded: [] }>()

// Read global settings to choose the renderer
const pitcherSettings = inject<ComputedRef<OrganizationSettings & InstanceSettings>>(
  'pitcherSettings',
  computed(() => ({})),
)

const rendererName = computed<'image' | 'pdfjs' | 'pspdfkit'>(
  () => pitcherSettings?.value?.canvas?.scribble_file_renderer || 'pdfjs',
)
const shouldRender = computed(() => rendererName.value !== 'image' && !!props.pdfUrl && props.pdfUrl.trim() !== '')
</script>
